import * as React from 'react';
import { TFooter } from './Footer.types';
import { Instagram } from '@mui/icons-material';
import './Footer.styled.scss';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import { Link } from 'react-router';
import { APP_ROUTES } from '../../../constants/routes';

export const Footer: TFooter = () => {
  const localize = useLocalize();

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__section footer__section--about">
          <h3 className="footer__title">
            <Link to={APP_ROUTES.ABOUT_US} className="footer__link-item">
              {localize('footer.section.about.title')}
            </Link>
          </h3>
          <p className="footer__text">
            {localize('footer.section.about.text')}
          </p>
        </div>

        <div className="footer__section footer__section--links">
          <h3 className="footer__title">
            {localize('footer.section.quick.links.title')}
          </h3>
          <ul className="footer__links">
            <li className="footer__link">
              <Link to={APP_ROUTES.PHONE_CASES} className="footer__link-item">
                {localize('footer.link.courses')}
              </Link>
            </li>
            <li className="footer__link">
              <Link
                to={`${APP_ROUTES.LEGAL_POLICIES}#privacy-policy`}
                className="footer__link-item"
              >
                {localize('footer.link.privacy.policy')}
              </Link>
            </li>
            <li className="footer__link">
              <Link
                to={`${APP_ROUTES.LEGAL_POLICIES}#terms-of-service`}
                className="footer__link-item"
              >
                {localize('footer.link.terms.of.service')}
              </Link>
            </li>
            <li className="footer__link">
              <Link
                to={`${APP_ROUTES.LEGAL_POLICIES}#refund-return-policy`}
                className="footer__link-item"
              >
                {localize('footer.link.refund.return.policy')}
              </Link>
            </li>
            <li className="footer__link">
              <Link
                to={`${APP_ROUTES.LEGAL_POLICIES}#complaints-warranty-policy`}
                className="footer__link-item"
              >
                {localize('footer.link.complaints.warranty.policy')}
              </Link>
            </li>
            <li className="footer__link">
              <Link
                to={`${APP_ROUTES.LEGAL_POLICIES}#shipping-policy`}
                className="footer__link-item"
              >
                {localize('footer.link.shipping.policy')}
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer__section footer__section--social">
          <h3 className="footer__title">
            {localize('footer.section.follow.title')}
          </h3>
          <div className="footer__social-icons">
            <a
              href="https://www.instagram.com/customgifts_pl?igsh=c3B5bzJiYzE1NmN5&utm_source=qr"
              target="_blank"
              rel="noreferrer"
              className="footer__social-icon"
              aria-label={localize('footer.aria.instagram') as string}
            >
              <Instagram />
            </a>
          </div>
        </div>

        <div className="footer__section footer__section--contact">
          <h3 className="footer__title">
            <Link to={APP_ROUTES.CONTACTS} className="footer__link-item">
              {localize('footer.section.contact.title')}
            </Link>
          </h3>
          <p className="footer__text">
            {localize('footer.contact.email.label')}{' '}
            <a
              href="mailto:support@customgifts.pl"
              className="footer__link-item"
            >
              support@customgifts.pl
            </a>
          </p>
          <p className="footer__text">{localize('footer.contact.phone')}</p>
        </div>
      </div>

      <div className="footer__bottom">
        <p className="footer__bottom-text">
          {localize('footer.bottom.copyright')}
        </p>
      </div>
    </footer>
  );
};
